'use client'

import { Fragment, ReactNode } from 'react'

import { CHART_COLORS } from '../../constants/chart'
import { ChartType, TooltipProps } from '../../types/Dashboard/types'

export default function ChartTooltip({
  active,
  allLabels,
  chartType,
  entryPayloadFilter,
  formatter,
  label,
  labelColors,
  labelFormatter,
  payload,
  visibility,
}: TooltipProps) {
  if (!active || !payload?.length) return null

  const filteredPayload = payload
    .map(entry => (entryPayloadFilter ? entryPayloadFilter(entry) : { ...entry }))
    .filter(entry => entry !== null)

  const effectiveLabel = chartType === ChartType.PIE ? filteredPayload[0]?.name : label

  let extraInfo: ReactNode | null = null
  return (
    <div className="tooltip backdrop-blur-[4.5px] p-3 pb-2.5 rounded-lg border border-[#323232] text-start text-white text-xs inline-block">
      <div>{labelFormatter && effectiveLabel ? labelFormatter(effectiveLabel, filteredPayload) : effectiveLabel}</div>
      <div className="grid-auto gap-x-1">
        {filteredPayload.map((entry, index) => {
          const isVisible = visibility?.[index] ?? 1
          if (!isVisible) return null
          const indexKey = chartType !== ChartType.LINE ? effectiveLabel : entry.name
          const colorIndex = indexKey ? (allLabels?.indexOf(indexKey.toString()) ?? 0) : 0
          const color = labelColors?.[entry.name ?? ''] ?? CHART_COLORS[colorIndex % CHART_COLORS.length]
          extraInfo = entry.extraInfo ?? null
          return (
            <Fragment key={`${filteredPayload[0]?.value ?? ''}-${index}`}>
              <span className="min-w-[50px] w-fit" style={{ color }}>
                {formatter ? formatter(entry.value ?? 0, index) : entry.value}
              </span>
              {chartType !== ChartType.PIE && (
                <span className="w-fit ml-1 whitespace-nowrap" style={{ color }}>
                  {entry.name}
                </span>
              )}
            </Fragment>
          )
        })}
      </div>
      {extraInfo}
    </div>
  )
}
